"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const ValueText = styled_components_1.default.label `
  font-style: normal;
  text-align: left;
  font-size: ${({ theme }) => theme.fontSize};
  font-stretch: ${({ theme }) => theme.fontStretch};
  font-weight: ${({ theme }) => theme.fontWeight};
  align-items: baseline;
  letter-spacing: ${({ theme }) => theme.letterSpacing};
  line-height: ${({ theme }) => theme.lineHeight};
  outline: none;
  color: ${({ theme }) => theme.fontColor};
  cursor: ${({ htmlFor, isDisabled }) => {
    if (isDisabled) {
        return 'not-allowed';
    }
    return htmlFor ? 'pointer' : 'default';
}};
  ${({ shouldWrapText }) => (shouldWrapText ? 'display: flex;' : (0, polished_1.ellipsis)())}
  overflow-wrap: anywhere;
`;
exports.default = ValueText;
